import { Navigate, Route, Routes } from 'react-router-dom';
import { ShopProvider } from './shop';
import { CartPage } from './pages/CartPage';
import { CataloguePage } from './pages/CataloguePage';
import { ProductPage } from './pages/ProductPage';

function Shop() {
  return (
    <ShopProvider>
      <Routes>
        <Route index element={<CataloguePage />} />
        <Route path="p/:productSlug" element={<ProductPage />} />
        <Route path="cart" element={<CartPage />} />
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </ShopProvider>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/:slug/*" element={<Shop />} />
      <Route path="*" element={<NoShop />} />
    </Routes>
  );
}

function NoShop() {
  return (
    <div className="min-h-dvh grid place-items-center p-6 text-center text-stone-500">
      <p>Open the shop link you were sent on WhatsApp.</p>
    </div>
  );
}
